import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import './style.scss';
import { useStore } from '../../../stores/Store';
import ViewClientPage from './ViewClient';
import { TextInput, OutlinedButton } from '../../../components';
import { processProjectsData, fetchProsAndLeads, getUserJobs,formatCash,formatDate, processProjectsAndBriefs } from '../../../utils/sharedFunctions';


const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const AtoZ = `${process.env.REACT_APP_CDN_URL}/globalAssets/A-ZFilter.svg`;
const ZtoA = `${process.env.REACT_APP_CDN_URL}/globalAssets/Z-AFilter.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
var mobile = require('is-mobile');

const Clients = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsMenuOpen, setIsMenuOpen] = useState(false);
    const [AddNewClient, setAddNewClient] = useState(false);
    const [ViewClient, setViewClient] = useState(false);
    const [Clients, setClients] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [AllUsers, setAllUsers] = useState([]);
    const [NewClientInfo, setNewClientInfo] = useState({
        authenticators: [],
        accountType: "",
        bio: "",
        briefs: [],
        businessType: null,
        city: "",
        companyName: null,
        companyRegistrationNumber: null,
        companyRole: null,
        companyVatNumber: null,
        companyWebsite: null,
        country: "",
        createdAt: "",
        date: new Date(),
        email: "",
        firstName: "",
        fullName: "",
        imgUrl: "",
        lastName: "",
        notifications: [],
        permissions: [],
        phone: "",
        professional: {
            worksuite: {},
            worksuiteId: null,
            gender: "",
            languages: "",
            race: "",
        },
        projects: [],
        role: "",
        roles: [],
        state: ""
    });
    const [SelectedClientID, setSelectedClientID] = useState('');
    const [TotalJobs, setTotalJobs] = useState('A-Z');
    const [SelectedClient, setSelectedClient] = useState({});
    const [NameFilter, setNameFilter] = useState('A-Z');
    const [ClientNoFilter, setClientNoFilter] = useState('A-Z');
    const [Payments, setPayments] = useState('A-Z');
    const [CompName, setCompName] = useState('A-Z')
    const [DateCreated, setDateCreated] = useState('A-Z');
    const [searchTerm, setSearchTerm] = useState('');
    const [TypeSelected, setTypeSelected] = useState('Personal');
    const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const [ClientJobs, setClientJobs] = useState([])
    const [Professionals, setProfessionals] = useState([]);
    const [IsEdited, setIsEdited] = useState(false)
    const [PageNum, setPageNum] = useState(0)

    useEffect(() => {
        getClients();
    }, [IsEdited]);
    const getClients = async () => {
        try {
            store.setLoading(true);

            const [projects, Briefs, Users, projectPlans, evaluation, quotes, vouchers] = await Promise.all([
                store.getProjects(),
                store.getBriefs(),
                store.getUsers(),
                store.getProjectPlans(),
                store.getEvaluation(),
                store.getQuote()
            ]);

            const validBriefs = processProjectsData(
                Briefs ?? [],
                projectPlans ?? [],
                projects ?? [],
                evaluation ?? [],
                vouchers ?? [],
                quotes ?? [],
                { Pros: Users.filter(user => user.roles[0] === 1988), Leads: Users.filter(user => user.roles[0] === 1987), Clients: Users.filter(user => user.roles[0] === 1989) }
            );
            
            const processedUsers = await fetchProsAndLeads(Users)
            const allUsers = processedUsers.Leads.concat(processedUsers.Pros, processedUsers.Clients);
            const processProject_Brief = processProjectsAndBriefs(projects, validBriefs, processedUsers.Leads, evaluation, processedUsers.Clients, projectPlans)
            const processedProjects = processProject_Brief.processedProjects.filter(item => item && item.client)
            const updatedUsers = getUserJobs(allUsers, processedProjects, validBriefs)

            const updatedClients = updatedUsers.filter(user => user.roles[0] === 1989 && user.businessType !== null).sort((a, b) => {
                const nameA = `${a.firstName || ''} ${a.lastName || ''}`.toLowerCase();
                const nameB = `${b.firstName || ''} ${b.lastName || ''}`.toLowerCase();
                return nameA.localeCompare(nameB);
            });

            setClients(updatedClients);
            setLeads(updatedUsers.filter(user => user.roles[0] === 1987));
            setProfessionals(updatedUsers.filter(user => user.roles[0] === 1988));
            setAllUsers(updatedUsers);
            forceUpdate();
        } catch (error) {
        } finally {
            store.setLoading(false);
        };
    };
    const openMenu = () => {
        setIsMenuOpen(true);

    };
    const closeMenu = () => {
        setIsMenuOpen(false);

    };
    const handleAddClient = () => {
        setAddNewClient(true);
        setIsMenuOpen(false)

    };
    const handleViewClient = (clientId, client) => {
        setSelectedClientID(clientId);
        setSelectedClient(client);
        setViewClient(true);

    };
    const handleClientInfoChange = (e) => {
        let client = { ...NewClientInfo };
        if (typeof client === 'object') {
            client.type = String(TypeSelected).toLocaleLowerCase();
            client.accountType = String(TypeSelected).toLocaleLowerCase();
            client.role = 'Client';
            client.roles = [1989];
        } else {
            return
        }
        if (e.currentTarget.id === 'Name') {
            let fullName = e.target.value;
            client.firstName = fullName.split(' ')[0];
            client.lastName = fullName.split(' ')[1];
            client['fullName'] = `${client.firstName} ${client.lastName}`
        }
        if (e.currentTarget.id === 'ClientNum') {
            client.ClientNumber = e.target.value;
        }
        if (e.currentTarget.id === 'Email') {
            client.email = e.target.value;
        }
        if (e.currentTarget.id === 'Organisation') {
            client.organisation = e.target.value;
        }
        if (e.currentTarget.id === 'ContactNum') {
            client.phone = e.target.value;
        }
        if (e.currentTarget.id === 'Address') {
            client.address = e.target.value;
        }
        if (e.currentTarget.id === 'CompName') {
            client.companyName = e.target.value;
        }
        if (e.currentTarget.id === 'RegistrationNum') {
            client.registrationNumber = e.target.value;
        }
        if (e.currentTarget.id === 'TaxIdentification') {
            client.taxIdentification = e.target.value;
        }
        if (e.currentTarget.id === 'Website') {
            client.website = e.target.value;
        }
        if (e.currentTarget.id === 'Industry') {
            client.industry = e.target.value;
        }
        setNewClientInfo(client);

    };
    const closeAddNewClient = () => {
        setAddNewClient(false);

    };
    const saveNewClient = async () => {
        try {
            store.setLoading(true);
            let client = NewClientInfo;

            if (client.type === 'Personal') {
                let regexPass = EmailRegex.test(client.email);
                if (!regexPass) {
                    alert('Please enter a valid email address.');
                    return;
                }
            }

            if (TypeSelected === 'Company') {
                if (!client.companyName) {
                    alert('Please enter a company name.');
                    return;
                }
                if (!client.registrationNumber) {
                    alert('Please enter a company registration number.');
                    return;
                }
                if (!client.taxIdentification) {
                    alert('Please enter a company tax identification number.');
                    return;
                }
            } else {
                const requiredFields = ['firstName', 'lastName', 'email', 'phone'];
                for (let field of requiredFields) {
                    if (!client[field]) {
                        alert(`Please fill in the ${field} field.`);
                        return;
                    }
                }
                if (!EmailRegex.test(client.email)) {
                    alert('Please enter a valid email address.');
                    return;
                }
            }

            let addClient = await store.createUser(client);
            if (!addClient) {
                alert('Failed to add client.');
                return;
            }
            addClient['fullName'] = `${addClient.firstName || ''} ${addClient.lastName || ''}`;
            let clients = [];
            clients.push(addClient);

            clearClientUseState();
            getClients();
            setAddNewClient(false);
            setViewClient(false);
        } catch (e) {
            console.log(e);
        }
    };
    function backClicked(back, isEdited) {
        if (isEdited) {
            getClients();
            setIsEdited(isEdited)
        }
        setViewClient(back);
        forceUpdate();
    };
  
    const handleTitleFilterComps = (e) => {
        let clients = [...Clients];
        let id = e.target.id;
    
        switch (id) {
            case 'ClientName':
                if (NameFilter === 'Z-A') {
                    setNameFilter('A-Z');
                    clients.sort((a, b) => (a.firstName || '').toLowerCase().localeCompare((b.firstName || '').toLowerCase()));
                } else {
                    setNameFilter('Z-A');
                    clients.sort((a, b) => (b.firstName || '').toLowerCase().localeCompare((a.firstName || '').toLowerCase()));
                }
                break;
    
            case 'compName':
                if (CompName === 'Z-A') {
                    setCompName('A-Z');
                    clients.sort((a, b) => (a.companyName || '').toLowerCase().localeCompare((b.companyName || '').toLowerCase()));
                } else {
                    setCompName('Z-A');
                    clients.sort((a, b) => (b.companyName || '').toLowerCase().localeCompare((a.companyName || '').toLowerCase()));
                }
                break;
    
            case 'ClientNo':
                if (ClientNoFilter === 'Z-A') {
                    setClientNoFilter('A-Z');
                    clients.sort((a, b) => String(a._id || '').localeCompare(String(b._id || '')));
                } else {
                    setClientNoFilter('Z-A');
                    clients.sort((a, b) => String(b._id || '').localeCompare(String(a._id || '')));
                }
                break;
    
            case 'TotalJobs':
                if (TotalJobs === 'Z-A') {
                    setTotalJobs('A-Z');
                    clients.sort((a, b) => (a.briefs?.length || 0) + (a.projects?.length || 0) - ((b.briefs?.length || 0) + (b.projects?.length || 0)));
                } else {
                    setTotalJobs('Z-A');
                    clients.sort((a, b) => (b.briefs?.length || 0) + (b.projects?.length || 0) - ((a.briefs?.length || 0) + (a.projects?.length || 0)));
                }
                break;
    
            case 'payment':
                if (Payments === 'Z-A') {
                    setPayments('A-Z');
                    clients.sort((a, b) => (a.totalPayments || 0) - (b.totalPayments || 0));
                } else {
                    setPayments('Z-A');
                    clients.sort((a, b) => (b.totalPayments || 0) - (a.totalPayments || 0));
                }
                break;
    
            case 'date':
                if (DateCreated === 'Z-A') {
                    setDateCreated('A-Z');
                    clients.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
                } else {
                    setDateCreated('Z-A');
                    clients.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
                }
                break;
    
            default:
                console.warn(`Unhandled sort case: ${id}`);
                break;
        }
    
        setClients(clients);
        // forceUpdate(); // Possibly unnecessary if setClients triggers re-render
    };
    
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);

    };
    const filteredClients = Clients.filter(client => {
        const searchValue = searchTerm.toLowerCase();
        return (String(client?.firstName ? `${client.firstName} ${client.lastName}` : '').toLowerCase().includes(searchValue) ||
            (client.email && client.email.toLowerCase().includes(searchValue)) ||
            (client.companyName && client.companyName.toLowerCase().includes(searchValue))
        );
    });
    const handleTabChange = (e) => {
        clearClientUseState()
        setTypeSelected(e.currentTarget.id);
    };
    function clearClientUseState() {
        let client = { ...NewClientInfo };
        client.type = '';
        client.industry = '';
        client.accountType = '';
        client.firstName = '';
        client.lastName = '';
        client.fullName = '';
        client.email = '';
        client.phone = '';
        client.website = '';
        client.address = '';
        client.taxIdentification = '';
        client.companyName = '';
        client.role = '';
        client.roles = [];
        setNewClientInfo(client);
    };

    function handlePageChange(e) {
        const ID = e.currentTarget.id
        let pageNum = PageNum;
        if (ID === 'next') {
            pageNum += 1;
        } else {
            pageNum -= 1
        };
        setPageNum(pageNum);
    };
    const chunkSize = 10;
    const chunkedFilteredClients = [];
    for (let i = 0; i < filteredClients.length; i += chunkSize) {
        chunkedFilteredClients.push(filteredClients.slice(i, i + chunkSize));
    };
    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='clientsPage'>
                <div className='clientsPageHeader'>
                    <p>Clients</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>

                <div className='clientsPageBody'>
                    {(ViewClient) ?

                        <ViewClientPage allUsers={AllUsers} backClick={(e, isEdited) => { backClicked(e, isEdited) }} leads={Leads} pros={Professionals} selectedPro={SelectedClient} />

                        :

                        <div className='clientList'>
                            {/* HEADER SECTION */}
                            <div className='clientListHeader'>
                                <div className='clientListSection'>
                                    <p>Client List</p>
                                    {store.user.permissions.includes("Client_Create") ? (<div className='openAddClient' onMouseEnter={openMenu} onMouseLeave={closeMenu}>...
                                        {(IsMenuOpen) ?
                                            <div className='clientMenuOpen'>
                                                <div className='AddClientConatiner'>
                                                    <img src={AddIcon} alt='Add Client' onClick={handleAddClient} />
                                                    <p onClick={handleAddClient}>Add Client</p>
                                                </div>
                                                <hr />
                                            </div> : null}
                                    </div>) : null}
                                </div>
                                <div className='numofItems'>
                                    <p className='spancular'>{Array.isArray(chunkedFilteredClients) && chunkedFilteredClients.length > 0 ? chunkedFilteredClients[PageNum].length : 0}</p>
                                </div>
                                <div className='search-bar-section' style={{ width: '25%', height: '60%' }}>
                                    <img src={SearchIcon} alt='Search Icon' />
                                    <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange} value={searchTerm}></input>
                                </div>

                            </div>

                            <div className='clientListContent' >
                                <div className='clientContentCover'>
                                    <div className='clientListLabels'>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='ClientName'>Client Name</p>
                                            <img src={NameFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='ClientName' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='ClientNo'>Contact Number</p>
                                            {/* <img src={ClientNoFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='ClientNo' onClick={handleTitleFilterComps} /> */}
                                        </div>
                                        <div className='ClientNameSect' style={{ minWidth: '10dvw' }}>
                                            <p>Client Details</p>
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='compName'>Company Name</p>
                                            <img src={CompName === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='compName' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect' style={{ minWidth: '10dvw' }}>
                                            <p onClick={handleTitleFilterComps} id='TotalJobs'>Total Jobs</p>
                                            <img src={TotalJobs === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='TotalJobs' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='payment'>Total Client Payments</p>
                                            <img src={Payments === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='payment' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='date'>Date Created</p>
                                            <img src={DateCreated === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='date' onClick={handleTitleFilterComps} />
                                        </div>

                                    </div>

                                    <div className='availableClientSection'>
                                        {store.user.permissions.includes("User_View") ? (
                                            Array.isArray(chunkedFilteredClients) && chunkedFilteredClients.length > 0 ? chunkedFilteredClients[PageNum].length === 0 && ClientJobs.length === 0 ? (
                                                <p>No clients found</p>
                                            ) :
                                                (
                                                    Array.isArray(chunkedFilteredClients) && chunkedFilteredClients.length > 0 ? chunkedFilteredClients[PageNum]?.map((item, index) => {
                                                        return (
                                                            <div className='clientCard' key={index}>
                                                                <p className='clientName'> {`${item.firstName || ''} ${item.lastName || ''}`}</p>
                                                                <p className='clientName'>{item?.phone ? item.phone : ''}</p>
                                                                <p className='clientName viewClient-Container' style={{ minWidth: '10dvw', }} onClick={() => handleViewClient(item._id, item)}>View</p>
                                                                <p className='clientName'> {`${item.companyName ?? ''}`}</p>
                                                                <p className='clientName' style={{ minWidth: '10dvw' }}>{item?.jobCount ?? 0}</p>
                                                                <p className='clientName'>{`ZAR ${formatCash(item.totalPayments || 0)}`}</p>
                                                                <p className='clientName' style={{ minWidth: '12dvw' }}>{formatDate(item.createdAt)}</p>
                                                            </div>
                                                        );
                                                    }) : null
                                                ) : null
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className='togglePages'>
                                {PageNum > 0 ? <p style={{ cursor: 'pointer' }} onClick={handlePageChange} id='prev'>Previous</p> : <p>Previous</p>}
                                <p>{PageNum + 1}/{chunkedFilteredClients.length}</p>
                                {chunkedFilteredClients.length > PageNum + 1 ? <p onClick={handlePageChange} id='next' style={{ cursor: 'pointer' }}>Next</p> : <p>Next</p>}
                            </div>

                        </div>
                    }
                </div>

                {/* ADD CLIENT REGION */}
                {(AddNewClient) ?
                    <div className='addClientPopUp'>
                        <div className='clientHeaderSect'>
                            <p>Create Client</p>
                        </div>
                        <div className='viewBriefTypeSect'>
                            <div className={(TypeSelected === 'Personal' ? 'selectedType' : 'typeCard')} id='Personal' onClick={handleTabChange}>
                                <p>Personal</p>
                            </div>
                            <div style={{ marginLeft: '1.5%' }} className={(TypeSelected === 'Company' ? 'selectedType' : 'typeCard')} id='Company' onClick={handleTabChange}>
                                <p>Company</p>
                            </div>
                        </div>
                        {(TypeSelected === 'Company') ?
                            <div className='clientInputFields'>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.companyName} label='Company Name' placeholder='Company Name' id='CompName' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.companyRegistrationNumber} label='Company Registration' placeholder='Company Registration' id='RegistrationNum' onChange={handleClientInfoChange}></TextInput>
                                </div>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.taxIdentification} label='Tax Identification' placeholder='Tax Identification' id='TaxIdentification' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.companyWebsite} label='Website' placeholder='Website' id='Website' onChange={handleClientInfoChange}></TextInput>
                                </div>
                                <div className='textInputrContainer' style={{ justifyContent: 'flex-start', marginLeft: '5%' }}>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.industry} label='Industry' placeholder='Industry' id='Industry' onChange={handleClientInfoChange}></TextInput>
                                </div>
                            </div>
                            : <div className='clientInputFields'>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' label='Name & Surname' placeholder='Name & Surname' id='Name' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.email} label='Email' placeholder='Email' id='Email' onChange={handleClientInfoChange}></TextInput>
                                </div>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.phone} label='Contact No.' placeholder='Contact No.' id='ContactNum' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.address} label='Address' placeholder='Address' id='Address' onChange={handleClientInfoChange}></TextInput>
                                </div>
                            </div>
                        }

                        <div className='actionSection'>
                            <OutlinedButton className='cancelButton' onClick={closeAddNewClient}>Cancel</OutlinedButton>
                            <OutlinedButton className='saveButton' onClick={saveNewClient}>Save</OutlinedButton>
                        </div>
                    </div> : null
                }
            </div>
        )
    }
})

export default Clients;